import { Box } from "@mui/system";
import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { createSearchParams, useLocation, useNavigate } from "react-router-dom";
import {
  allFilters,
  filterHeaderSearchOrganization,
} from "../../redux/actions/filterActions";
import { filterHeaderOrganization } from "../../redux/store/storeConstants";
import { filterKeys } from "../../utils/constants/filters";
import { leadsEndpoints } from "../../utils/constants/httpConstants";
import { AutoCompleteCustom } from "../Autocomplete";
import { styles } from "./styles";
import Checkbox from "../Buttons/Checkbox/Checkbox";
import { STRINGS } from "../../screens/Leads/strings";

const FilterTypeOrganization = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const allFiltersSelector = useSelector(
    (state) => state?.allFilters?.payload,
  ) || {
    exist_fields: [],
    not_exist_fields: [],
  };

  const selectedOrganizationFilter = useSelector(
    (state) => state.filterHeaderOrganization?.payload,
  ) || {
    anyOf: false,
    notAnyOf: false,
    isKnown: false,
    isUnknown: false,
  };

  const ORGANIZATION_OPTIONS = [
    { id: "government", label: STRINGS.GOVERNMENT },
    { id: "educational", label: STRINGS.EDUCATIONAL },
    { id: "public", label: STRINGS.PUBLIC },
    { id: "private", label: STRINGS.PRIVATE },
  ];

  const handleOrganizationChange = (item, filter) => {
    let payload = {
      ...selectedOrganizationFilter,
      [item]: !selectedOrganizationFilter[item],
      isKnown: false,
      isUnknown: false,
    };

    const unCheckPayload = {};
    if (!payload.anyOf) unCheckPayload[filter] = [];
    if (!payload.notAnyOf) unCheckPayload[filter + "_not"] = [];

    dispatch(
      allFilters({
        ...unCheckPayload,
        exist_fields: allFiltersSelector.exist_fields.filter(
          (e) => e !== filter,
        ),
        not_exist_fields: allFiltersSelector.not_exist_fields.filter(
          (e) => e !== filter,
        ),
      }),
    );

    navigate({
      pathname: location.pathname,
      search: createSearchParams({
        ...allFiltersSelector,
        ...unCheckPayload,
        exist_fields: allFiltersSelector.exist_fields.filter(
          (e) => e !== filter,
        ),
        not_exist_fields: allFiltersSelector.not_exist_fields.filter(
          (e) => e !== filter,
        ),
      }).toString(),
    });

    dispatch(filterHeaderSearchOrganization(payload));
  };

  const handleOrgAutoCompleteChange = (data, type) => {
    const filterKey = filterKeys.organization + type;
    const ids = data.id;

    dispatch(allFilters({ [filterKey]: ids }));

    navigate({
      pathname: location.pathname,
      search: createSearchParams({
        ...allFiltersSelector,
        [filterKey]: ids,
      }).toString(),
    });
  };

  const getSelectedValue = (type) => {
    const filterKey = filterKeys.organization + type;
    const selectedIds = allFiltersSelector[filterKey] || [];
    return ORGANIZATION_OPTIONS.filter((opt) => selectedIds.includes(opt.id));
  };

  return (
    <Box sx={styles.container}>
      <Box sx={styles.filterContainer}>
        <div style={styles.jobTitleHead}>
          <Checkbox
            checked={!!selectedOrganizationFilter.anyOf}
            onClick={() =>
              handleOrganizationChange("anyOf", filterKeys.organization)
            }
            label={STRINGS.IS_ANY_OF}
          />
        </div>
        {selectedOrganizationFilter.anyOf && (
          <Box sx={{ mt: 1 }}>
            <AutoCompleteCustom
              multiple
              items={ORGANIZATION_OPTIONS}
              idState={allFiltersSelector[filterKeys.organization] || []}
              valueState={getSelectedValue("").map((opt) => opt.label)}
              onChange={(data) => handleOrgAutoCompleteChange(data, "")}
              placeholder="Select Organization Type"
            />
          </Box>
        )}

        <div style={styles.jobTitleHead}>
          <Checkbox
            checked={!!selectedOrganizationFilter.notAnyOf}
            onClick={() =>
              handleOrganizationChange("notAnyOf", filterKeys.organization)
            }
            label={STRINGS.IS_NOT_ANY_OF}
          />
        </div>
        {selectedOrganizationFilter.notAnyOf && (
          <Box sx={{ mt: 1 }}>
            <AutoCompleteCustom
              multiple
              items={ORGANIZATION_OPTIONS}
              idState={
                allFiltersSelector[filterKeys.organization + "_not"] || []
              }
              valueState={getSelectedValue("_not").map((opt) => opt.label)}
              onChange={(data) => handleOrgAutoCompleteChange(data, "_not")}
              placeholder="Select Organization Type"
            />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default FilterTypeOrganization;
